<template>
  <router-view />
</template>

<script>
export default {
  name: "app-courseType"
};
</script>

<style lang="scss" scoped></style>
